import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MUITable from "../../../../Common/MUITable";
import Loader from "../../../../Common/Loader/loader";
import isGHMC, { formatDateTimeWithoutSec, formattedDate, formattedDateTypeTwo, getCurrentDateTime } from "../../../../Common/helper/helpar";
import { MSWManagementVehiclesInnerExport } from "./MSWManagementVehiclesInnerExport";
import MSWManagementSecondaryCollectionStore from "./store/MSWManagementSecondaryCollectionStore";

export const MSWManagementVehiclesOnRoadInnerReport = () => {
  
  const {
    fetchMSWManagementSecondaryCollectionInnerReport,
    loading,
    MSWManagementSecondaryCollectionInnerReportData,
    setkpi5outerData,
    kpi5outerData
  } = MSWManagementSecondaryCollectionStore(); 

  const isProd = isGHMC();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { reportDate } = state || {};

  useEffect(() => {
    const params = reportDate ? { reportDate } : {};
    fetchMSWManagementSecondaryCollectionInnerReport(params);
  }, [reportDate]);


  const validRows = (MSWManagementSecondaryCollectionInnerReportData || []).filter(
    (row) =>
      row.ZoneName ||
      row.CircleName ||
      row.PlannedVehicleCount ||
      row.DeployedVehicleCount ||
      row.hklVehicleCapacity
  );

  /* ================= TOTAL ROW ================= */
  const totalRow =
    validRows.length > 0
      ? {
        ZoneName: "Total",
        CircleName: "",
        PlannedVehicleCount: validRows.reduce(
          (sum, r) => sum + Number(r.PlannedVehicleCount || 0),
          0
        ),
        DeployedVehicleCount: validRows.reduce(
          (sum, r) => sum + Number(r.DeployedVehicleCount || 0),
          0
        ),
        DeploymentPercentage: (() => {
          const planned = validRows.reduce(
            (sum, r) => sum + Number(r.PlannedVehicleCount || 0),
            0
          );
          const deployed = validRows.reduce(
            (sum, r) => sum + Number(r.DeployedVehicleCount || 0),
            0
          );
          return planned > 0
            ? ((deployed / planned) * 100).toFixed(2)
            : "0.00";
        })(),
        hklVehicleCapacity: validRows.reduce(
          (sum, r) => sum + Number(r.hklVehicleCapacity || 0),
          0
        ),
      }
      : null;


  /* ================= TABLE COLUMNS ================= */
  const mswManagementSecondaryInnerHeaderColumns = [
    {
      label: "Zone Name",
      field: "ZoneName",
      render: (row) => (
        <div style={{ fontWeight: row.ZoneName === "Total" ? "bold" : "normal" }}>
          {row.ZoneName}
        </div>
      ),
    },
    {
      label: "Circle Name",
      field: "CircleName",
      render: (row) => (
        <div style={{ fontWeight: row.ZoneName === "Total" ? "bold" : "normal" }}>
          {row.CircleName}
        </div>
      ),
    },
    {
      label: "Alloted Vehicles",
      field: "PlannedVehicleCount",
      render: (row) => (
        <div style={{ fontWeight: row.ZoneName === "Total" ? "bold" : "normal" }}>
          {row.PlannedVehicleCount}
        </div>
      ),
    },
   {
  label: "Deployed Vehicles",
  field: "DeployedVehicleCount",
  render: (row) => {
    const isTotal = row.ZoneName === "Total";

    return (
      <div
        style={{
          fontWeight: isTotal ? "bold" : "normal",
          cursor: isTotal ? "default" : "pointer",
          color: isTotal ? "black" : "blue",
          textDecoration: isTotal ? "none" : "",
        }}
        onClick={() => {
          if (!isTotal) {
            setkpi5outerData(row);
            navigate("/deployed-inner-report");
          }
        }}
      >
        {row.DeployedVehicleCount}
      </div>
    );
  },
},
    {
      label: "Deployment %",
      field: "DeploymentPercentage",
      render: (row) => (
        <div style={{ fontWeight: row.ZoneName === "Total" ? "bold" : "normal" }}
       
        >
          {row.DeploymentPercentage}
        </div>
      ),
    },
    // {
    //   label: "HKL Vehicle Capacity",
    //   field: "HKLVehicleCapacity",
    //   render: (row) => (
    //     <div style={{ fontWeight: row.ZoneName === "Total" ? "bold" : "normal" }}>
    //       {row.HKLVehicleCapacity ?? 0}
    //     </div>
    //   ),
    // },
  ];

  const storedFilters = localStorage.getItem("mswSecondaryCollectionFilters");
  const parsedFilters = JSON.parse(storedFilters);

  const storedDate = localStorage.getItem("MSWManagementVehiclesDate");
  const parsedDate = JSON.parse(storedDate);


  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  };

  const currentDate = getCurrentDateTime();

  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">
          <div className="d-flex justify-content-end align-items-end mt-3">
            <button className="btn btn-secondary me-2" onClick={() => navigate(-1)}>
              Back
            </button>
            <MSWManagementVehiclesInnerExport fromDate={reportDate} toDate={reportDate}/>
          </div>

          <div className="card mt-3">
            <div className="card-body">
              <div
                className="top-header p-2"
                style={{
                  backgroundColor: "#D7D7D7",
                  fontWeight: "600",
                  borderBottom: "1px solid #DDDDDD",
                }}
              >
                <span>Detailed Vehicle Deployment Data Report as on ({formattedDate(parsedDate)}) at {formatDateTimeWithoutSec(currentDate)}</span>
              </div>

              {loading ? (
                <Loader />
              ) : (
                <MUITable
                  needSRNumber
                  hasTotalRow
                  tableHeight={500}
                  columns={mswManagementSecondaryInnerHeaderColumns}
                  rows={
                    totalRow
                      ? [...validRows, totalRow]
                      : validRows
                  }
                />

              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
